import * as React from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import esArray from "./functionEsArray";

export const HistoricoMermas = ({ data }) => {

    const datos = esArray(data.values);
    // Renderiza el timeline solo si hay datos
    return (
        <>
            {datos?.length > 0 ? (
                <Timeline position="alternate">
                    {datos.map((item, index) => (
                        <TimelineItem key={index}>
                            <TimelineOppositeContent
                                sx={{ m: "auto 0" }}
                                align="right"
                                variant="body2"
                                color="text.secondary"
                            >
                                {new Date(item.fecha_hora).toLocaleString()}
                            </TimelineOppositeContent>
                            <TimelineSeparator>
                                <TimelineConnector />
                                <TimelineDot
                                    style={{ background: "white", border: "2px solid #000000" }}
                                >
                                    {/* Puedes cambiar el icono según el tipo de evento, si corresponde */}
                                </TimelineDot>
                                <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent sx={{ py: "2.5%", px: 2 }}>
                                <Typography variant="h6" component="span">
                                    <strong>Valor Original:</strong> {item.valor_original}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    <strong>Valor Editado:</strong> {item.valor_editado}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    <strong>Usuario:</strong> {item.usuario}
                                </Typography>
                            </TimelineContent>
                        </TimelineItem>
                    ))}
                </Timeline>
            ) : (
                <Grid style={{ textAlign: 'center', alignContent: 'center' }}>
                    <Typography variant="h5" gutterBottom style={{ color: '#3c4b64' }}>
                        Aun no posee un historial.
                    </Typography>
                </Grid>
            )}
        </>
    );
};

export default HistoricoMermas;
